import i18n from '@/i18n'
import store from '@/store'
import { Layouts } from '@/layouts'

const layout = Layouts.ON_BOARDING
export const ONBOARDING_INVESTOR_ENTRY_POINT = 'hz-investor-property-purchase'

function navigationGuard(to, from, next) {
  const hasData = store.getters['stepper/hasData']
  if (hasData) {
    next()
  } else {
    next({ name: ONBOARDING_INVESTOR_ENTRY_POINT })
  }
}

const title = i18n.global.t('horiz.onboarding.meta.page-title')
const description = i18n.global.t('horiz.onboarding.meta.description')
const featureImageUrl = 'https://horiz.io/imgs/Horiz-accompagnement-immobilier.png'
const featureImageAltText = i18n.global.t('horiz.onboarding.meta.img-alt')

const onbaordingMetas = (url) => ({
  title,
  metaTags: [
    {
      name: 'description',
      content: description,
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'og:image',
      content: featureImageUrl,
    },
    {
      property: 'og:url',
      content: `https://horiz.io/onboarding/investor/${url}`,
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      property: 'og:site_name',
      content: 'https://horiz.io',
    },
    {
      name: 'twitter:image:alt',
      content: featureImageAltText,
    },
  ],
})

const routes = [
  {
    component: () => import('@/views/Onboardings/Investor/PropertyPurchase.vue'),
    path: 'step/propertyPurchase',
    name: ONBOARDING_INVESTOR_ENTRY_POINT,
    meta: {
      ...onbaordingMetas('step/propertyPurchase'),
      step: 'step1-purchase',
      available: true,
      ignorePresentPushNotifications: true,
      spontaneousInteractionAllowed: false,
      layout,
    },
  },
  {
    beforeEnter: navigationGuard,
    component: () => import('@/views/Onboardings/Investor/RealEstate.vue'),
    path: 'step/realEstate',
    name: 'hz-investor-real-estate',
    meta: {
      ...onbaordingMetas('step/realEstate'),
      step: 'step2-property',
      available: true,
      layout,
      ignorePresentPushNotifications: true,
      spontaneousInteractionAllowed: false,
    },
  },
  {
    beforeEnter: navigationGuard,
    component: () => import('@/views/Onboardings/Investor/Tenant.vue'),
    path: 'step/tenant',
    name: 'hz-investor-tenant',
    meta: {
      ...onbaordingMetas('step/tenant'),
      step: 'step3-tenants',
      available: true,
      layout,
      ignorePresentPushNotifications: true,
      spontaneousInteractionAllowed: false,
    },
  },
]

export default routes
